// extracted by mini-css-extract-plugin
export default {"containerSearch":"tableSearch_containerSearch__M1loA"};